import Message from "carbon-react/esm/components/message";

interface EmptyStateProps {
  children: string;
  title: string;
}

export function EmptyState({ children, title }: EmptyStateProps) {
  return (
    <section aria-label={title} className="application-state">
      <Message open title={title} variant="info">
        {children}
      </Message>
    </section>
  );
}